import axios from 'axios'

export default {
  searchCompanies(searchStr, writeTo) {
    return axios.post(process.env.MAXX_DOMAIN + '/forms/api/searchCompanies', {
      className: 'Company',
      extraData: [],
      returnAttr: 'quickSearch',
      searchAttr: 'quickSearch',
      term: searchStr
    }).then(function (response) {
      const results = response.data.response.map(item => {
        let name = `${item.isParent ? '*' : ''}${item.label} [${item.membershipStatus.toUpperCase()}]`

        return {
          name,
          id: item.value,
        }
      })
      return results;
    }).catch(error => error)
  },
  getCompany(companyId) {
    return axios.get(process.env.MAXX_DOMAIN + '/forms/api/getCompany?company_id=' + companyId, {withCredentials: true})
    .then(function(response) {
      return response.data
    }).catch(error => error)
  },
  getCompanyStaff(companyId) {
    return axios.get(process.env.MAXX_DOMAIN + '/forms/api/getCompanyStaff?company_id=' + companyId, {withCredentials: true})
    .then(function(response) {
      return response.data
    }).catch(error => error)
  },
  getIndividuals(usersList) {
    return axios.post(process.env.MAXX_DOMAIN + '/forms/api/getIndividuals',
    {
      users: JSON.stringify(usersList)
    },
    {withCredentials: true})
    .then(response => {
      if (response.data.error) {
        console.log(response.data.error)
        return Promise.reject(response.data.error)
      }
      return response.data
    })
  },
  getMeetings() {
    return axios.get(process.env.MAXX_DOMAIN + '/forms/api/getApptSchedulerMeetings', {withCredentials: true})
    .then(response => {
      return response.data
    })
  },
  createActivity(meetingId, companyId, suiteName, addedOrRemoved) {
    return axios.post(process.env.MAXX_DOMAIN + '/forms/api/createApptActivity',
    {
      'meeting_id': meetingId,
      'company_id': companyId,
      'suite_name': suiteName,
      'added_or_removed': addedOrRemoved
    },
    {withCredentials: true})
    .then(response => {
      if (response.data !== 'OK') {
        return Promise.reject(new Error('could not complete request'))
      }
    })
  },
  createBatchActivity(activityArray) {
    // takes an array of Objects with the same keys as createActivity uses and
    // writes each of them as an activity in Maxx
    return axios.post(process.env.MAXX_DOMAIN + '/forms/api/createBatchApptActivity',
    activityArray,
    {withCredentials: true})
  },
  getUpdatedUsers(users) {
    // pass in an array of userdata objects that have a key of username and value of user data object
    // returns: [good, missing]
    // good is the same user data object updated with new values if the user exists
    // and company has not changed
    // missing is users who have changed companies or no longer could be found by username

    return axios.post(process.env.MAXX_DOMAIN + '/forms/api/getUpdatedUsers', {
      users
    },
    {withCredentials: true})
    .then(response => {
      try {
        if ('error' in response.data) {
          return Promise.reject(new Error(response.data.error))
        }
        if ('good' in response.data && 'missing' in response.data) {
          return response.data
        } else {
          throw new Error('Error retrieving data from MatrixMaxx')
        }
      } catch (e) {
        return Promise.reject(new Error('Error retrieving data from MatrixMaxx'))
      }
    })
  },
  getMeetingRegistrations(meetingId) {
    return axios.get(process.env.MAXX_DOMAIN + '/forms/api/getMeetingRegistrants?meeting_id=' + meetingId,
    {withCredentials: true}
    )
    .then(response => {
      return response.data
    })
  },
  testjson() {
    return axios.get(process.env.MAXX_DOMAIN + '/forms/api/testjson', {withCredentials: true})
    .then(function(response) {
    return response.data
    })
    .catch(error => error)
  },
}


// WEBPACK FOOTER //
// ./src/services/maxxapi.js